import { KoobContainer } from '@koob/ui';
import React from 'react';

// The content under an experience page's header, the same on every tab.
export default function ExperienceLayout({ children }) {
  return <KoobContainer>{children}</KoobContainer>;
}
